import { render, staticRenderFns } from "./DetailTableCdp.vue?vue&type=template&id=127b7530&"
import script from "./DetailTableCdp.vue?vue&type=script&lang=ts&"
export * from "./DetailTableCdp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports